module.exports = __webpack_public_path__ + "static/media/AMC-main-icon.0d19a2d3.svg";